<template>
  <div class="container py-7">
    <div class="row">
      <div class="col-lg-12 d-flex justify-content-center">
        <!--        <date-picker v-model="date" is-range-->
        <!--                     :columns="$screens({ default: 1, lg: 3 })"-->
        <!--                     :rows="$screens({ default: 1, lg: 4 })"-->
        <!--                     :is-expanded="$screens({ default: true, lg: false })"/>-->
        <date-picker :modelValue="days"
                     :attributes="attributes" @dayclick="onDayClick"
                     :select-attribute="selectAttribute"
                     :columns="4"
                     :rows="2"
                     :is-expanded="true">
          <template #day-popover="{ day, format, masks }">
            <div class="text-md text-gray-300 font-semibold text-center">
              Haha: {{ format(day.date, masks.dayPopover) }}
              <br>
              <button href="#">Submit</button>
            </div>
          </template>
        </date-picker>
        <input type="hidden" name="days" :value="this.days.map(day=>day.id)"/>
      </div>
    </div>
  </div>
</template>

<script>

import {Calendar, DatePicker} from 'v-calendar';
import 'v-calendar/dist/style.css';

export default {
  components: {
    Calendar,
    DatePicker
  },
  props: {
    old: Array,
  },
  data: function () {
    return {
      selectAttribute: {
        dot: true,
      },
      days: [],
    }
  },
  computed: {
    dates() {
      return this.days.map(day => day.date);
    },
    attributes() {
      // console.log('attributes have changed');
      // console.log(this.dates);

      return this.dates.map(date => ({
        highlight: {
          color: 'blue',
          fillMode: 'light',
        },
        dates: date,
      }));
    },
  },
  methods: {
    showing() {
      // console.log('showing');
    },
    onDayClick(day) {
      // console.log('clicking day');
      // console.log(this.days);
      const idx = this.days.findIndex(d => d.id === day.id);
      if (idx >= 0) {
        this.days.splice(idx, 1);
      } else {
        this.days.push({
          id: day.id,
          date: day.date,
        });
      }
    },
  },
  mounted() {
    this.old.forEach(day => {
      this.days.push({
        id: day.day,
        date: new Date(day.day),
      })
    });
  },
}
</script>

<style scoped>

</style>
